import store from '@state/store'

function processNotification(notification) {
  if (notification.type === 'TEXT') {
    store.commit('notifications/ADD', notification)
  } else {
    store.commit('notifications/ADD', {
      ...notification,
      duration: 10000,
    })
  }
  store.commit('userNotifications/ADD', notification)
}

export default processNotification
